import { writable } from "svelte/store";
export const pointerStore = writable(null);
